import styled from '/web_modules/styled-components.js';
import React from '/web_modules/react.js';
import { motion } from '/web_modules/framer-motion.js';
import { Spinner } from './Spinner.js';
import { gap } from './Layout.js';
const SeparatorWrap = styled(motion.div).withConfig({
  displayName: "Separator__SeparatorWrap",
  componentId: "sc-12ryjr-0"
})(["font-family:'Playfair Display';font-size:24px;display:flex;align-items:center;color:#353535;line-height:1;.versus{padding:0 16px;font-size:33.898305084745765px;:before{content:'';margin-top:-0.29297500000000011em;display:block;height:0;}:after{content:'';margin-bottom:--0.060025em;display:block;height:0;}}", "{margin:0 16px;}@media screen and (min-width:800px){flex-direction:column;", "}"], Spinner, gap('16px', 'column'));
const Line = styled.span.withConfig({
  displayName: "Separator__Line",
  componentId: "sc-12ryjr-1"
})(["height:1px;background:#353535;flex-grow:1;position:relative;:after{content:'';display:inline-block;width:100%;position:absolute;top:4px;left:4px;background:#bbb;}@media screen and (min-width:800px){width:1px;height:auto;}"]);

const SeparatorComponent = ({
  isLoading,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(SeparatorWrap, props, /*#__PURE__*/React.createElement(Line, null), isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement("span", {
    className: "versus"
  }, "vs"), /*#__PURE__*/React.createElement(Line, null));
};

export const Separator = styled(SeparatorComponent).withConfig({
  displayName: "Separator",
  componentId: "sc-12ryjr-2"
})([""]);